import { OpaccBasketAction } from './vendor/script/classes/opacc.class.basket-action.js';

export default class TEBasketAction extends OpaccBasketAction {
    constructor() {
        super();
    }

    attachEventListener() {
        if (this.wrapperElement) {
            this.changeDimVariant();

            // Ausloesen des Click-Events bei Aenderung (nur Touch-Button "Change")
            this.wrapperElement.addEventListener('change', (e) => {
                let inputItem = e.target.closest(`${this.basketButtonContainer}[data-op-layout="touch"]`);
                if (inputItem) {
                    let basketBtn = inputItem.querySelector('button[data-op-btnaction="change"]');
                    if (basketBtn) {
                        basketBtn.click();
                    }
                }
            });

            this.wrapperElement.addEventListener('click', (e) => {
                let modalButton = e.target.closest('[data-op-modal]');
                if (modalButton) {
                    let base64 = modalButton.dataset.opModal;
                    let htmlEncoded = window.atob(base64);
                    let htmlDecode = document.createElement('div');
                    htmlDecode.innerHTML = htmlEncoded;
                    opaccLogPlugin.showModal(htmlDecode.innerText);
                }

                // change Quantity with + and - Buttons
                let itemChangeQuantity = e.target.closest(`${this.basketButtonContainer}[data-op-layout="touch"]`);
                if (itemChangeQuantity && e.target.hasAttribute('data-op-qtychange')) {
                    if (this.quantityChanger(e)) {
                        let item = itemChangeQuantity.querySelector(
                            `${this.basketButtonContainer} button[data-op-btnaction="change"]`,
                        );
                        if (item) {
                            // if change-button is present, then trigger the quantity change
                            item.click();
                        }
                    }
                }

                let itemsAdd = e.currentTarget.querySelectorAll(
                    `${this.basketButtonContainer} button[data-op-btnaction="add"], ${this.basketButtonContainer} button[data-op-btnaction="addall"]`,
                );
                let allBasketBtns = e.currentTarget.querySelectorAll(
                    `${this.basketButtonContainer}[data-op-modal],${this.basketButtonContainer} button[data-op-btnaction], ${this.basketButtonContainer} button[data-op-qtychange]`,
                );

                Array.from(itemsAdd).forEach((item) => {
                    if (item == e.target.closest(this.basketButtonSelector)) {
                        let inputField = item.parentElement.querySelector('input.basket-button-quantity');
                        let isValid = true;
                        if (inputField) {
                            isValid = this.validateQuantity(inputField, true);
                        }
                        if (isValid) {
                            item.dataset.opAsynctemplate = this.basketAsyncTemplate;
                            this.toggleButtonState(
                                Array.from(allBasketBtns).filter(
                                    (basketItem) => basketItem != e.target.closest(this.basketButtonSelector),
                                ),
                                'none',
                            );
                            item.classList.add('is-progress');
                            this.sendAjaxRequest(item);
                        }
                    }
                });

                let itemsModify = e.currentTarget.querySelectorAll(
                    `${this.basketButtonContainer} button[data-op-btnaction="delete"],
					${this.basketButtonContainer} button[data-op-btnaction="change"],
					${this.basketButtonContainer} button[data-op-btnaction="deleteall"]`,
                );

                let targetItem = Array.from(itemsModify).filter(
                    (item) => item == e.target.closest(this.basketButtonSelector),
                );

                if (targetItem.length > 0) {
                    this.toggleButtonState(
                        Array.from(itemsModify).filter((item) => item != e.target.closest(this.basketButtonSelector)),
                        'none',
                    );
                    this.toggleQuantityChangerState(this.getQuantityChangerElements(e.target), 'none');
                    let item = targetItem[0];
                    item.classList.add('is-progress');
                    if (item.dataset.opBtnaction == 'change') {
                        this.validateQuantity(item.parentElement.querySelector('input.basket-button-quantity'), true);
                    }
                    item.dataset.opAsynctemplate = this.basketAsyncTemplate;
                    this.sendAjaxRequest(item);
                }

                if (e.target.closest('.customers-also-bought')) {
                    location.reload();
                }
            });
        }
    }
}
